import {
    apiRequest,
    skillcertificationDetail,
    skillcertificationUpdate,
    masterRegion
} from "../../../../../../services/adapters/kepegawaian/skillcertificationService"

class UpdateRepository {

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", skillcertificationDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", skillcertificationUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository